import React, { useState, forwardRef, useImperativeHandle } from 'react';
import PropTypes from "prop-types";
import { Input } from 'semantic-ui-react';

/**
 * SimpleCvvInput component
 * A simple CVV input field for Credit Guard and other providers
 * that don't require SDK-based CVV collection
 * @param {boolean} isMandatory - If true, shows required indicator
 */
const SimpleCvvInput = forwardRef(({ isMandatory }, ref) => {
    const [cvv, setCvv] = useState('');

    const handleChange = (e, { value }) => {
        // Only allow digits, max 4 characters (some cards have 4-digit CVV)
        const cleanValue = value.replace(/\D/g, '').slice(0, 4);
        setCvv(cleanValue);
    };

    const getCvv = () => {
        return cvv;
    };

    useImperativeHandle(ref, () => ({
        getCvv: () => {
            return getCvv();
        }
    }));

    return (
        <div className="cvv-container simple-cvv" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <Input
                placeholder={isMandatory ? "CVV *" : "CVV"}
                value={cvv}
                onChange={handleChange}
                maxLength={4}
                style={{ width: '80px' }}
                size="mini"
            />
        </div>
    );
});

SimpleCvvInput.displayName = 'SimpleCvvInput';
SimpleCvvInput.propTypes = {
    isMandatory: PropTypes.bool,
};

export default SimpleCvvInput;
